<template>
  <div
    class="indoorsDataDetWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftMenuBox">
      <MenuList @getClickData="getClickData" @setListData="setListData" />
    </div>
    <div class="contentBox">
      <div class="mapBox">
        <MapView :menuData="menuData" />
        <el-form :inline="true" class="selectBox">
          <el-form-item label="">
            <el-select v-model="parameter" clearable placeholder="选择参数">
              <el-option
                v-for="item in parameterList"
                :key="item.key"
                :label="item.name"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="margin-left: 10px"
              @click="subTypeSelect"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="detailsList">
        <div class="identification" v-if="clickData.deviceId">
          <img
            :src="
              require(`@/assets/images/xitong/${
                clickData.status == '在线'
                  ? 'online'
                  : clickData.status == '离线'
                  ? 'offline'
                  : 'alert'
              }.png`)
            "
          />
        </div>
        <ul>
          <li
            v-for="(v, i) in list"
            :key="i"
            :class="activeKey == v.key ? 'activeLi' : ''"
            @click="changeKey(v)"
          >
            <p>{{ v.name }}</p>
            <h5 :style="{ color: v.status == '异常' ? '#EC5453' : '#333' }">
              {{ v.value }}
            </h5>
            <span>{{ v.unit }}</span>
          </li>
        </ul>
      </div>
      <div class="chartsBox">
        <PublicEcharts
          :id="'lineBox'"
          :chartsData="chartsData"
          :type="'shadowLine'"
        />
      </div>
    </div>
    <div class="rightListBox ashComWrap">
      <div class="comTitle">
        <h4>今日告警记录</h4>
        <div class="more" @click="$router.push('/alarmManagement')">更多</div>
      </div>
      <div class="comContentBox">
        <AlarmListCom />
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { dateFtt } from "@/assets/js/utils";
import MenuList from "@/components/zixitong/indoorEnvironment/MenuList";
import MapView from "@/components/zixitong/indoorEnvironment/MapView";
import AlarmListCom from "@/components/zixitong/indoorEnvironment/AlarmListCom";
import PublicEcharts from "@/components/PublicEcharts";
import { ANGLEDEFAULT } from "@/assets/js/const";
import { handleNumDecimal } from "@/assets/js/utils";
export default {
  components: {
    MenuList,
    MapView,
    AlarmListCom,
    PublicEcharts,
  },
  data() {
    return {
      list: [],
      clickData: {}, //页面中选中项
      menuData: {
        EMSList: [],
        clickData: {}, //传递给地图的选中值
      },
      parameter: "", //参数
      parameterList: [],
      activeKey: "",
      activeList: {},
      chartsData: {
        xData: [],
        yData: [],
        unit: "",
      },
      status: "",
    };
  },
  methods: {
    async subTypeSelect() {
      let res = await api.subsystemIndoorListByType({
        modular: "环境监测",
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        status: this.status,
        key: this.parameter,
      });
      if (res && res.data.code == 200) {
        let data = res.data.data;
        if (data.length > 0) {
          data.map((v) => {
            v.state =
              v.status == "在线"
                ? "online"
                : v.status == "离线"
                ? "offline"
                : "alert";
          });
          this.menuData.EMSList = data;
          this.menuData.clickData = data[0];
          this.getMapClick(data[0]);
        } else {
          this.menuData.EMSList = [];
          this.clickData = {};
          this.handleListData();
        }
      }
    },
    changeKey(item) {
      this.activeKey = item.key;
      this.activeList = item;
      this.$store.commit("SET_LOADING", true);
      this.getChartsData();
    },
    // 获取左侧列表数据在地图上打点
    setListData(data) {
      this.parameter = "";
      this.menuData.EMSList = data;
    },
    // 获取左侧列表点击选中设备
    getClickData(data) {
      if (data.activeItem?.deviceId) {
        this.menuData.clickData = data.activeItem;
        this.clickData = {
          deviceId: data.activeItem.deviceId,
          status: data.activeItem.status,
        };
        this.status = data.status;
        this.handleListData();
      } else {
        this.clickData = {};
        this.handleListData();
      }
    },
    // 获取地图上点击的设备
    getMapClick(data) {
      this.clickData = data;
      this.$bus.$emit("handleMapClick", data);
      this.handleListData();
    },
    // 处理选中值后的地图底部列表及echarts
    handleListData() {
      this.list = [];
      this.chartsData.xData = [];
      this.chartsData.yData = [];
      this.chartsData.unit = "";
      if (this.clickData.deviceId) {
        this.getListData();
      } else {
        this.$message.error("未选择设备");
      }
    },

    // 获取地图上参数列表
    async getTypeList() {
      let res = await api.subsystemIndoorType({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        modular: "环境监测",
      });
      if (res && res.data.code == 200) {
        this.parameterList = res.data.data;
      }
    },
    async getListData() {
      let res = await api.subsystemIndoorValue({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceId: this.clickData.deviceId,
      });
      if (res && res.data.code == 200) {
        this.list = res.data.data;
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].key === "Angle") {
            this.list[i].value =
              ANGLEDEFAULT?.[Number(this.list[i].value)] || "";
            return;
          } else {
            this.list[i].value = handleNumDecimal(this.list[i].value);
          }
        }

        if (this.list.length > 0) {
          this.activeKey = this.list[0].key;
          this.activeList = this.list[0];
          this.getChartsData();
        }
      }
    },
    async getChartsData() {
      this.chartsData.xData = [];
      this.chartsData.yData = [];
      this.chartsData.unit = "";
      let res = await api.subsystemIndoorCharts({
        modular: "环境监测",
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        deviceId: this.clickData.deviceId,
        name: this.activeList.name,
        key: this.activeKey,
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        res.data.data.map((v) => {
          this.chartsData.xData.push(dateFtt("hh:mm", new Date(v.ts)));
          this.chartsData.yData.push(v.data.value);
        });
        this.chartsData.unit = res.data.data.length
          ? res.data.data[0].data.unit
          : "";
      }
    },
  },
  created() {
    this.getTypeList();
  },
  mounted() {
    this.$bus.$on("getMapClickFun", (data) => {
      this.getMapClick(data);
    });
  },
  beforeDestroy() {
    this.$bus.$off("handleMapClick");
  },
};
</script>

<style lang="scss" scoped>
.indoorsDataDetWrap {
  @include setFlexBetween;
  .leftMenuBox {
    width: 21%;
    height: 100%;
    background: #fff;
  }
  .contentBox {
    width: 55.5%;
    height: 100%;
    @include setFlexColumn;
    justify-content: center;
    .mapBox {
      width: 100%;
      height: 68%;
      position: relative;
      .selectBox {
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 500;
      }
    }
    .detailsList {
      width: 100%;
      height: 15%;
      background: #fff;
      @include setFlexBetween;
      .identification {
        width: 10%;
        height: 100%;
        @include setFlexCenter;
        img {
          width: 50%;
        }
      }
      ul {
        width: 90%;
        height: 90%;
        @include setFlexStart;
        li {
          width: 12%;
          height: 100%;
          border-right: 1px solid #e9e9e9;
          @include setFlexColumn;
          justify-content: center;
          align-items: center;
          p {
            color: #666;
          }
          h5 {
            margin: 10px 0;
            font-size: 20px;
          }
          span {
            color: #999;
          }
        }
        li:last-child {
          border: none;
        }
        .activeLi {
          background: #e9e9e9;
          border-radius: 10px;
        }
      }
    }
    .chartsBox {
      width: 100%;
      height: 15%;
      background: #fff;
    }
  }
  .rightListBox {
    width: 22%;
    height: 98%;
    .more {
      color: #28cccb;
      cursor: pointer;
      border-bottom: 1px solid transparent;
    }
    .more:hover {
      border-color: #28cccb;
    }
  }
}
</style>
